import { Component, OnInit, ViewEncapsulation, Input, OnChanges } from '@angular/core';
import {IVariantGroupingType} from "../../Interfaces/IVariantGroupingType";

@Component({
  selector: 'kws-product-variant-grid',
  templateUrl: './product-variant-grid.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ProductVariantGridComponent implements OnInit {
  constructor() { }
  @Input() displayType: string;
  @Input() viewMode: string;
  @Input() cardType: string;

  @Input() products: IVariantGroupingType[];
  @Input() variantGroupingTypes: IVariantGroupingType[];
  @Input() variantGroupingTypesSingle: IVariantGroupingType;

  ngOnInit() {

  }

  showFeature(index) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/ts/Apps/Common/components/product-variant-grid/product-variant-grid.component.ts